// extracted by mini-css-extract-plugin
export default {"root":"HeaderCartButton_root__vm2Rr","menuItemImage":"HeaderCartButton_menuItemImage__ojd1S","loader":"HeaderCartButton_loader__W7CjW"};